/**
 * Determines whether a user role is granted access according to an allowed roles list.
 *
 * @param {string} userRole - Role identifier of the user (for example, 'admin', 'user').
 * @param {Array<string>} [allowedRoles=[]] - Array of allowed role identifiers. If omitted or empty, access is denied.
 * @returns {boolean} True when the user's role is present in the allowedRoles array; otherwise false.
 */
export function hasUserAccess(userRole, allowedRoles = []) {
    return allowedRoles.includes(userRole);
}